///<reference path='../../typings/index.d.ts' />
///<reference path='pixilayer.ts' />

module agi.expressions.card.layer {

    import Event = agi.expressions.event.Event;
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;
    import MovieClip = PIXI.extras.MovieClip;

    export class UI extends PixiLayer{
        private renderer:PIXI.WebGLRenderer|PIXI.CanvasRenderer;
        private assetManifest:AssetManifest;
        private hintContainer:PIXI.Container;
        private hintArrowContainer:PIXI.Container;
        private instruction:PIXI.Sprite;
        private hint:PIXI.Sprite;
        private hintArrow:PIXI.Sprite;
        public hintTimeline:TimelineMax;
        private userInteracted:boolean = false;
        public hintTimeoutId:number;
        private instructionTimeoutId:number;
        private onMoveBind:any;

        constructor(){
            super();
        }

        public init(options:SceneOptions){
            this.renderer = options.renderer;         
            this.assetManifest = options.assetManifest;

            this.hintContainer = new PIXI.Container();
            this.hintContainer.position = new PIXI.Point(0,0);
            this.instruction = PIXI.Sprite.fromFrame(this.assetManifest.ui.instruction);
            this.instruction.position = new PIXI.Point(136,-100);
            this.hint = PIXI.Sprite.fromFrame(this.assetManifest.ui.hint);
            this.hint.position = new PIXI.Point(150,-100);

            this.hintArrow = PIXI.Sprite.fromFrame(this.assetManifest.ui.arrow);
            this.hintArrow.position = new PIXI.Point(350,302);
            this.hintArrowContainer = new PIXI.Container();
            this.hintArrowContainer.alpha = 0;
            this.hintArrowContainer.addChild(this.hintArrow);
            
            this.hintTimeline = new TimelineMax({repeat:-1});
            this.hintTimeline.set(this.hintArrow,{alpha:0});
            this.hintTimeline.add(TweenLite.to(this.hintArrow,2,{x:385,ease:Linear.easeNone}));
            this.hintTimeline.add(TweenLite.to(this.hintArrow,0.6,{alpha:1}),0);
            this.hintTimeline.add(TweenLite.to(this.hintArrow,0.6,{alpha:0}),1.4);
            this.hintTimeline.play();

            this.hintContainer.addChild(this.hint);
            this.hintContainer.addChild(this.instruction);
            this.addChild(this.hintContainer);
            this.addChild(this.hintArrowContainer);

            this.eventBus.addEventListener("playButtonClicked", this.playClickedHandler.bind(this));
            this.onMoveBind = this.onMove.bind(this);
            this.eventBus.addEventListener("userMove", this.onMoveBind);
            this.eventBus.addEventListener("revealReset", this.revealReset.bind(this));
        }

        public reset(){
            this.userInteracted = false;
            this.visible = true;
            this.instruction.y = -100;
            this.hint.y = 25;
            this.hint.alpha = 0;
            this.hintContainer.y = 0;
            TweenLite.killTweensOf(this.instruction);
            TweenLite.killTweensOf(this.hint);
        }

        public revealReset() {
            this.playInstructions();
            this.onMoveBind = this.onMove.bind(this);
            this.eventBus.addEventListener("userMove", this.onMoveBind);
        }

        public animate(deltaTime?:number){
            if(!this.isPlaying){
                this.isPlaying=true;
            }else{
            }
        }

        protected playInstructions(){
            TweenLite.to(this.instruction,1.2,{y:0,startAt:{y:-100},ease:Quad.easeOut});
            this.hintTimeoutId = setTimeout(()=>{this.fireAdditionalHelpUI();}, 5000);
        }

        protected fireAdditionalHelpUI():void {
            TweenMax.to(this.hint,1.6,{y:95,alpha:1,startAt:{y:25,alpha:0},ease:Quad.easeOut});
            var glowEvent:Event = new Event("glowOn", this);
            this.eventBus.dispatchEvent(glowEvent);
            TweenLite.to(this.hintArrowContainer,1,{alpha:1});
        }

        protected playClickedHandler(event:Event) {
            this.playInstructions();
        }

        public onMove(event:Event) {
           if(!this.userInteracted){
               this.userInteracted = true;
               TweenLite.to(this.hintContainer,1,{y:-200});
               TweenLite.killTweensOf(this.hintArrowContainer);
               TweenLite.to(this.hintArrowContainer,1,{alpha:0});
               var glowEvent:Event = new Event("glowOff", this);
               this.eventBus.dispatchEvent(glowEvent);
               clearTimeout(this.instructionTimeoutId);
               clearTimeout(this.hintTimeoutId);
               this.eventBus.removeEventListener("userMove", this.onMoveBind);
           }
        }
    }
}
